export const navLinks = [
  { label: '首页', href: '/' },
  { label: '关于我们', href: '/about' },
  { label: '产品中心', href: '/product-center' },
  { label: '应用案例', href: '/cases' },
];

export const heroSlides = [
  {
    id: 1,
    title: '科技赋能',
    subtitle: '助力业务创新 降本增效',
    image: 'https://readdy.ai/api/search-image?query=Minimal%20dark%20abstract%20geometric%20background%2C%20deep%20charcoal%20gray%20with%20subtle%20clean%20blue%20gradient%20edges%2C%20smooth%20matte%20surface%20texture%2C%20modern%20corporate%20technology%20aesthetic%2C%20no%20particles%20no%20glowing%20effects%2C%20restrained%20and%20elegant%2C%20Apple%20style%20dark%20mode%20banner&width=1600&height=700&seq=hero-tech-minimal-01&orientation=landscape',
  },
  {
    id: 2,
    title: '以数字驱动',
    subtitle: '实现高价值管理',
    image: 'https://readdy.ai/api/search-image?query=Modern%20architectural%20skyline%20silhouette%20at%20dusk%2C%20clean%20geometric%20building%20lines%2C%20deep%20dark%20blue%20gray%20gradient%20sky%2C%20minimal%20corporate%20technology%20atmosphere%2C%20no%20neon%20lights%20no%20particles%2C%20restrained%20and%20professional%2C%20wide%20banner%20composition&width=1600&height=700&seq=hero-tech-minimal-02&orientation=landscape',
  },
  {
    id: 3,
    title: '网银盾智管',
    subtitle: '网银U盾智能管理 资金安全可视化',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20flowing%20data%20lines%20on%20dark%20background%2C%20thin%20elegant%20curved%20lines%20in%20subtle%20cool%20blue%20tones%2C%20deep%20charcoal%20base%2C%20clean%20modern%20corporate%20style%2C%20no%20glowing%20particles%20no%20neon%2C%20restrained%20technology%20visualization&width=1600&height=700&seq=hero-tech-minimal-03&orientation=landscape',
  },
];

export const aboutContent = {
  titleCn: '关于我们',
  titleEn: 'ABOUT US',
  description:
    '析莜科技（XIYOO）专注为国际企业、制造业、金融及零售电商行业提供企业级财务数智化整体解决方案。\n\n依托领先技术架构与行业经验，通过智能化技术，聚焦于财务领域最重要也是最繁杂的业务管理方向，采用软硬件一体手段，实现企业资金全面集中管控，高效完成企业资金账户全覆盖、解析全自动、数据标准化、动态监控、及时更新、精细管理、个性适配。帮助企业更好实现资金"看得见""管的住""用的好"。',
  cta: '了解更多',
  ctaHref: '/about',
  image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20corporate%20office%20interior%2C%20dark%20moody%20atmosphere%20with%20clean%20lines%2C%20glass%20and%20concrete%20architecture%2C%20subtle%20warm%20lighting%20accents%2C%20professional%20business%20environment%2C%20no%20holograms%20no%20glowing%20screens%2C%20restrained%20and%20elegant%20photography&width=600&height=500&seq=about-minimal-01&orientation=landscape',
  stats: [
    { label: '10年+', subLabel: '行业服务经验' },
    { label: '300+', subLabel: '知名客户往来' },
    { label: '>98%', subLabel: '客户满意度' },
  ],
};

export const advantagesContent = {
  titleCn: 'XIYOO优势',
  titleEn: 'WHY WE',
  image: 'https://readdy.ai/api/search-image?query=Minimal%20abstract%20geometric%20sculpture%20in%20dark%20studio%2C%20clean%20intersecting%20metal%20planes%20with%20subtle%20matte%20finish%2C%20deep%20charcoal%20background%2C%20modern%20art%20installation%2C%20corporate%20decorative%20element%2C%20no%20glowing%20edges%20no%20neon%2C%20restrained%20and%20sophisticated&width=500&height=600&seq=advantages-minimal-01&orientation=portrait',
  items: [
    {
      id: 1,
      icon: 'ri-shield-star-line',
      titleCn: '专业',
      titleEn: 'Professional',
      desc: '成熟的解决方案，专业的服务团队',
    },
    {
      id: 2,
      icon: 'ri-lightbulb-flash-line',
      titleCn: '创新',
      titleEn: 'Innovations',
      desc: '领先的技术，开拓进取凸显核心价值',
    },
    {
      id: 3,
      icon: 'ri-vip-crown-line',
      titleCn: '高端',
      titleEn: 'Advanced',
      desc: '来自世界大品牌的信赖，服务众多高奢品牌及世界500强企业',
    },
    {
      id: 4,
      icon: 'ri-shield-check-line',
      titleCn: '稳定',
      titleEn: 'Stabilization',
      desc: '用心对待每一次的交付，以改进客户服务体验为己任',
    },
    {
      id: 5,
      icon: 'ri-award-line',
      titleCn: '至善',
      titleEn: 'Consummate',
      desc: '全方位做到至善，力求在每一个细节中做到完美',
    },
  ],
};

export const productsContent = {
  titleCn: '产品与服务',
  titleEn: 'Product',
  items: [
    {
      id: 1,
      icon: 'ri-brain-line',
      titleCn: 'AI人工智能',
      titleEn: 'Artificial Intelligence',
      desc: 'NLP自然语言处理、OCR光学字符识别、智能数据分析',
      href: '/product-center/intro',
    },
    {
      id: 2,
      icon: 'ri-building-4-line',
      titleCn: '网银业务智管平台',
      titleEn: 'Online Banking Fund Platform',
      desc: 'ERP、CRM、供应链管理等一体化业务管理解决方案',
      href: '/product-center/fund-platform',
    },
    {
      id: 3,
      icon: 'ri-bank-line',
      titleCn: '网银盾智管平台',
      titleEn: 'Online Banking Shield Platform',
      desc: '网银U盾智能管理、资金可视化、AI识别与安全认证一体化平台',
      href: '/product-center/shield-platform',
    },
    {
      id: 4,
      icon: 'ri-usb-line',
      titleCn: '网银U盾服务器',
      titleEn: 'CloudUSB Server',
      desc: '24/45端口机柜型与桌面型，安全认证硬件设备',
      href: '/product-center/cloudusb-server',
    },
  ],
};

export const hardwareContent = {
  titleCn: '硬件设备',
  titleEn: 'NEW BURST',
  subtitle: '新品爆款',
  cta: '查看更多 >>',
  ctaHref: '/product-center/cloudusb-server',
  items: [
    {
      id: 1,
      title: '45端口 机柜型\n第二代网银U盾服务器',
      model: 'CloudUSB-K45',
      href: '/product-center/cloudusb-server/cloudusb-k45',
      image: 'https://storage.helloreaddy.io/project_files/d3244921-9c44-4475-bb7d-d9f1f2d3d4fd/9ae3f497-4e56-4104-ac4c-14101b8e2877_compressed_UCloudUSB-K45.webp',
    },
    {
      id: 2,
      title: '24端口 机柜型\n第二代网银U盾服务器',
      model: 'CloudUSB-K24',
      href: '/product-center/cloudusb-server/cloudusb-k24',
      image: 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/93c529138bb3cdbcdf1ff9b357c5211f.png',
    },
    {
      id: 3,
      title: '45端口 桌面型\n第二代网银U盾服务器',
      model: 'CloudUSB-MK45',
      href: '/product-center/cloudusb-server/cloudusb-mk45',
      image: 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/29f9ea5d5b59c0e11b6c6f935a302ce7.png',
    },
    {
      id: 4,
      title: '24端口 桌面型\n第二代网银U盾服务器',
      model: 'CloudUSB-MK24',
      href: '/product-center/cloudusb-server/cloudusb-mk24',
      image: 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/fd2f6e259c791ab2b3e7a0056160f172.png',
    },
  ],
};

export const casesContent = {
  titleCn: '经典案例',
  titleEn: 'CLASSIC CASE',
  items: [
    {
      id: 1,
      company: '中亿丰控股',
      project: '网银智能体项目',
      desc: '通过引入USBServer + AI智能体，实现数十家银行近千个U盾的自动调度与自动制单，大幅提升支付管控和资金运营效率',
      image: 'https://readdy.ai/api/search-image?query=Modern%20corporate%20construction%20group%20headquarters%20building%2C%20clean%20geometric%20architecture%2C%20dark%20moody%20professional%20atmosphere%2C%20minimal%20elegant%20corporate%20photography%2C%20no%20glowing%20effects%20no%20neon&width=600&height=400&seq=case-home-zhongyifeng&orientation=landscape',
      slug: 'zhongyifeng-holding',
      industry: '建筑领域',
    },
    {
      id: 2,
      company: '罗普斯金铝业',
      project: '网银智能体项目',
      desc: '通过引入USBServer + AI网银智能体，构建网银U盾集中管理与自动化下载平台，实现资金数据从银行端到业务系统的自动采集与归档',
      image: 'https://readdy.ai/api/search-image?query=Modern%20aluminum%20extrusion%20industrial%20plant%20exterior%2C%20clean%20geometric%20industrial%20architecture%2C%20dark%20moody%20professional%20atmosphere%2C%20minimal%20elegant%20corporate%20photography%2C%20no%20glowing%20effects%20no%20neon&width=600&height=400&seq=case-home-luopsijin&orientation=landscape',
      slug: 'luopsijin-aluminum',
      industry: '铝型材/系统门窗',
    },
  ],
};

export const coreAdvantagesContent = {
  titleCn: '核心优势',
  titleEn: 'CORE ADVANTAGE',
  items: [
    {
      id: 1,
      tabTitle: '中国质量强制认证CCC',
      title: '核心优势一：中国质量强制认证CCC',
      desc: '1、本行业率先通过CCC认证\n\n析莜CloudUSB系列网银U盾服务器，本行业率先通过中国质量认证中心CCC认证，支持CQC官方查验。\n\n2、认证价值\n网银U盾服务器属于其他服务器产品类别，CCC认证是进入等保三级机房的必要认证。\n\n3、温馨提示\n单一样品的测试或试验报告，只对送检样品负责，不能视为该供应商批量供货产品通过CCC体系认证。',
      image: 'https://readdy.ai/api/search-image?query=Minimal%20certificate%20and%20quality%20badge%20concept%2C%20clean%20geometric%20document%20shape%20with%20official%20seal%20silhouette%2C%20dark%20background%20with%20subtle%20warm%20gold%20accent%2C%20restrained%20and%20elegant%2C%20no%20glowing%20effects%2C%20corporate%20authority%20visual&width=500&height=500&seq=adv-ccc-minimal&orientation=squarish',
    },
    {
      id: 2,
      tabTitle: '等保三级安全测评',
      title: '核心优势二：等保三级安全测评',
      desc: '1、率先通过等保三级机房接入标准的安全测评\n\n析莜CloudUSB系列网银U盾服务器产品所配置的管理软件，采用SM2/SM3/SM4等国密加密算法，https加密传输；基于零信任机制的单次有效Token机制，防止越权访问；率先通过"等保三级"机房安全接入标准的网络安全测评。\n\n2、认证价值\n等保三级网络安全是央国企内网普遍采用的安全标准；网络安全测评是进入等保三级机房的必要条件。CloudUSB系列网银U盾管理系统，依托全面的安全策略，受到越来越多央国企的认可。\n\n3、温馨提示\n没有标注"安全等级标准"的测评报告，不一定符合等保三级机房的安全接入要求。',
      image: 'https://readdy.ai/api/search-image?query=Minimal%20cybersecurity%20shield%20concept%2C%20clean%20geometric%20shield%20shape%20with%20subtle%20lock%20detail%2C%20dark%20background%20with%20muted%20blue%20gray%20tones%2C%20restrained%20and%20professional%2C%20no%20glowing%20neon%2C%20no%20particles%2C%20corporate%20security%20visual&width=500&height=500&seq=adv-security-minimal&orientation=squarish',
    },
    {
      id: 3,
      tabTitle: '核心软件自主研发',
      title: '核心优势三：核心软件自主研发',
      desc: '1、拥有核心软件全部源代码\n\n析莜CloudUSB系列网银U盾服务器所配套的核心驱动软件，是完全拥有自主知识产权、代码级可控、可任意定制开发的核心软件。\n\n2、产品价值\nCloudUSB系列产品拥有全部源代码，可以承诺网银业务系统向国产操作系统迁移时，完全适配所有国产操作系统，代码级自主可控、可完全适配所有网银U盾。\n\n3、温馨提示\n网银业务系统由Windows操作系统向国产操作系统迁移已经是大势所趋；采用国外核心驱动程序的产品可能有兼容性风险。',
      image: 'https://readdy.ai/api/search-image?query=Minimal%20software%20development%20concept%2C%20clean%20abstract%20code%20lines%20and%20matrix%20grid%20pattern%2C%20dark%20background%20with%20subtle%20muted%20green%20blue%20tones%2C%20restrained%20and%20professional%2C%20no%20glowing%20effects%2C%20no%20particles%2C%20corporate%20tech%20visual&width=500&height=500&seq=adv-code-minimal&orientation=squarish',
    },
    {
      id: 4,
      tabTitle: '集成式模块化架构',
      title: '核心优势四：集成式模块化架构',
      desc: '1、基于发明专利技术的集成式模块化架构\n\n析莜CloudUSB系列网银U盾服务器，基于发明专利技术（专利号ZL 2024 1 0649301.0）的集成式模块化架构，得到了更多央国企用户和系统集成商的广泛认可。\n\n2、优势价值\n可操作性更强：模块化架构，装卸U盾更方便；\n稳定可靠性高：没有任何外部延长线，U盾信号质量有保障，更适合规模化部署；\n可维护性更强：无需技术人员即可更换机械臂，财务人员可自行维护设备。\n\n3、温馨提示\n模块化，一切复杂系统提升可靠性的必由之路。开放外挂式架构可能导致USB信号质量下降。',
      image: 'https://readdy.ai/api/search-image?query=Minimal%20modular%20architecture%20concept%2C%20clean%20interlocking%20geometric%20blocks%20forming%20a%20system%2C%20dark%20background%20with%20subtle%20cool%20blue%20and%20warm%20amber%20edges%2C%20restrained%20and%20elegant%2C%20no%20glowing%20neon%2C%20corporate%20tech%20visual&width=500&height=500&seq=adv-module-minimal&orientation=squarish',
    },
    {
      id: 5,
      tabTitle: '生物识别验证身份',
      title: '核心优势五：生物识别验证身份',
      desc: '1、基于指纹身份识别验证身份使用U盾\n\n析莜CloudUSB系列网银U盾管理系统，率先实现了基于生物识别验证身份的安全策略。引入指纹验证身份连接U盾和按压确认键，还原并提升了第二代U盾的安全机制。\n\n2、优势价值\n引入指纹验证身份的策略，是批量管理制单、审核等支付权限U盾的必要条件。\n\n3、温馨提示\n不采用计算机屏幕外的身份认证手段，相当于将第二代网银U盾降级为第一代网银U盾。无此安全策略，不适合管理制单、审核等支付类U盾。请谨慎采用。',
      image: 'https://readdy.ai/api/search-image?query=Minimal%20biometric%20fingerprint%20concept%2C%20clean%20geometric%20fingerprint%20pattern%20with%20subtle%20circular%20rings%2C%20dark%20background%20with%20muted%20blue%20tones%2C%20restrained%20and%20professional%2C%20no%20glowing%20neon%2C%20no%20light%20trails%2C%20corporate%20security%20visual&width=500&height=500&seq=adv-bio-minimal&orientation=squarish',
    },
    {
      id: 6,
      tabTitle: '悬浮按钮快捷操作',
      title: '核心优势六：悬浮按钮快捷操作',
      desc: '1、基于悬浮按钮快捷使用U盾\n\n析莜CloudUSB系列网银U盾管理系统，采用快捷按钮悬浮于任何业务管理和OA审批系统之上，实现了无需切换软件就能完成U盾连接、断开等快捷操作。\n\n2、优势价值\n避免反复多次切换操作软件，U盾使用效率提升3倍以上。\n\n3、温馨提示\nCloudUSB系列网银U盾管理系统，不仅仅是资金安全管理手段，也是效率提升能手。',
      image: 'https://readdy.ai/api/search-image?query=Minimal%20floating%20interface%20button%20concept%2C%20clean%20abstract%20UI%20elements%20and%20action%20button%20shapes%2C%20dark%20background%20with%20subtle%20light%20gray%20accents%2C%20restrained%20and%20professional%2C%20no%20glowing%20neon%2C%20no%20holographic%20effects%2C%20corporate%20tech%20visual&width=500&height=500&seq=adv-float-minimal&orientation=squarish',
    },
    {
      id: 7,
      tabTitle: '双向安全保护能力',
      title: '核心优势七：双向安全保护能力',
      desc: '1、全场景双向安全保护能力\n\n析莜CloudUSB系列网银U盾服务器，核心电路板自主研发。提供15KV防静电保护、过压过流保护、长期持续短路保护等安全措施。\n\n2、优势价值\nU盾损坏不会损坏设备；设备损坏不会损坏U盾。\n\n3、温馨提示\n基本的电路保护，只是安全稳定的最低要求，也是通过CCC认证的必要条件。',
      image: 'https://readdy.ai/api/search-image?query=Minimal%20dual%20protection%20security%20concept%2C%20two%20clean%20geometric%20shield%20barriers%20with%20subtle%20circuit%20pattern%2C%20dark%20background%20with%20muted%20blue%20and%20warm%20amber%20tones%2C%20restrained%20and%20professional%2C%20no%20glowing%20effects%2C%20no%20particles%2C%20corporate%20tech%20visual&width=500&height=500&seq=adv-protect-minimal&orientation=squarish',
    },
  ],
};

export const testimonialsContent = {
  titleCn: '部分客户反馈',
  titleEn: 'CLIENT FEEDBACK',
  items: [
    {
      id: 1,
      company: '某工程机械行业龙头企业',
      role: '人力资源主管',
      content: '"筛选速度快，晚上不用加班抢简历了，帮我们"抢人"，抢到最需要的人。"',
      scene: '使用场景：简历筛选',
    },
    {
      id: 2,
      company: '某工程机械行业龙头',
      role: '财务经理',
      content: '"能节省很大一部分时间，规范财务记账的标准，工作效率提高了。"',
      scene: '使用场景：采购及销售发票记账',
    },
    {
      id: 3,
      company: '世界500强能源巨头',
      role: '共享中心主管',
      content: '"这几个机器人平均每天初审500多单，工作量排名位居应付小组排名靠前。"',
      scene: '使用场景：应付单据审核',
    },
    {
      id: 4,
      company: '某央企世界500强龙头',
      role: '总经济师',
      content: '"项目总结会上，企业总经济师评价"选择北财"，是因为北财可能不是规模最大的，但一定是财务领域最认真、最专业的。"',
      scene: '使用场景：银企对账、资金支付提交及结果反馈',
    },
    {
      id: 5,
      company: '世界500强能源巨头',
      role: '共享中心主管',
      content: '"财务专业功底扎实，对账效果满足了我们实际工作需要。以前最头疼的对账问题大大缓解了，实施团队工作值得肯定。"',
      scene: '使用场景：银企对账',
    },
    {
      id: 6,
      company: '世界500强能源巨头',
      role: '共享中心主管',
      content: '"提高了运行效率、降低错误率，后期扩展纳税申报机器人在其他税种的应用，助力集团财务智能化水平的进一步提升。"',
      scene: '使用场景：增值税纳税申报',
    },
  ],
};

export const partnersContent = {
  titleCn: '合作伙伴',
  titleEn: 'Partners',
  partners: [
    {
      name: '中国人民保险',
      logo: 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/e0280953014510c49f355d5a34f56251.png',
    },
    {
      name: '中华保险',
      logo: 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/3e15338bbdcb2e11ef52f557f629394d.png',
    },
    {
      name: '中国平安',
      logo: 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/4368710dad6e9c0cb6bc0ff29c70d614.png',
    },
    {
      name: '捷豹 Jaguar',
      logo: 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/e47c66523f45694faae0082d085e027a.png',
    },
    {
      name: 'JAS',
      logo: 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/90dcc3831db7dfb398e11cf0c13345cc.png',
    },
    {
      name: 'JLG',
      logo: 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/cf0f02a7a81cce2611945bc1e74f060d.png',
    },
    {
      name: 'LVMH集团',
      logo: 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/1907613b0bacfd87daebe5b5e7479b65.png',
    },
    {
      name: '酩悦轩尼诗 MHD',
      logo: 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/958fecf2cc4e41aeb98d6c8ddc4ec549.png',
    },
    {
      name: 'Hennessy 轩尼诗',
      logo: 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/daf98e45e96c614b8325cf721b3c30f1.png',
    },
    {
      name: 'FENDI',
      logo: 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/b09e79c34139f6c1a19e592a27b3da29.png',
    },
    {
      name: 'Dior',
      logo: 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/0b1b0602a372f0e1d723d7a88787d47a.png',
    },
    {
      name: 'CHANEL',
      logo: 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/52fc50b85c88d56f1621d6b8a22af227.png',
    },
    {
      name: 'GODIVA',
      logo: 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/fa0a036698e9c3f63287543f5f9c06c2.png',
    },
    {
      name: '星巴克',
      logo: 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/892ce6da279f0d1989615f53cdea1a0f.png',
    },
    {
      name: 'Honeywell',
      logo: 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/3d13fcc06ba386771e6bdbbd000d9ffd.png',
    },
    {
      name: 'CMA CGM',
      logo: 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/91b4bdc2cad9f734e43a4f2a057302b9.png',
    },
    {
      name: 'BOBST',
      logo: 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/a122ad0ab690408d717516685c5901da.png',
    },
    {
      name: '均胜电子',
      logo: 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/8cd34068dfc4834d250ab6ed65bc530a.png',
    },
    {
      name: '保乐力加中国',
      logo: 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/0cde154e82ea54813023a4a503aa312f.png',
    },
    {
      name: 'Benz',
      logo: 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/3a3ce9174fda840aa71e4c710ebb34d2.png',
    },
    {
      name: 'Formel D',
      logo: 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/e69ce583098dc290af5437778b79a7b6.png',
    },
    {
      name: 'volvo',
      logo: 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/6fcf596e8133b7a26966e06c901fa564.png',
    },
    {
      name: 'dun',
      logo: 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/1876eb946d74f58275f468e54d5ce876.png',
    },
    {
      name: 'BRAUN',
      logo: 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/da5b3e64c4a97a013f45feb8ff3307cc.png',
    },
  ],
};

export const footerContent = {
  logoText: 'XIYOOTECHNOLOGY',
  columns: [
    {
      title: '我们所做:',
      links: ['AI人工智能', '网银业务智管平台', '网银盾智管平台', '网银U盾服务器'],
    },
    {
      title: '解决方案:',
      links: ['生产制造行业', '高奢侈行业', '物流行业', '汽车行业', '保险行业', '金融财务'],
    },
    {
      title: '联系我们',
      items: ['Contact: JAKE CHEN', 'Mail: Jake.chen@xi-yoo.com'],
    },
  ],
  copyright: 'Copyright \u00A9 2011-2021 qimajqr.All Rights Reserved.',
  icp: '沪ICP备18033609号-1',
  icpHref: 'https://beian.miit.gov.cn/',
};